import styled, { createGlobalStyle } from 'styled-components'
import { device, fonts, colors } from 'stylesheets'

export const GlobalStyle = createGlobalStyle`

  .react-datepicker-popper {
    left: auto !important;
    right: 160px;
    text-transform: capitalize;
  }

  .react-datepicker__header {
    background: ${colors.primary} !important;
    border-bottom: none !important;
  }

  .react-datepicker__day-names {
    background: ${colors.white};
  }

  .react-datepicker__triangle {
    display: none;
  }

  .react-datepicker__day {

    color: ${colors.greyDark} !important;

    &--disabled {
      color: ${colors.greySilver} !important;
    }

    &--selected ,
    &--in-selecting-range,
    &--in-range {
      border-radius: 20px !important;
      background-color: ${colors.primary} !important;
      color: ${colors.white} !important;
    }

    &:hover {
      background-color: ${colors.greyLighter};
      border-radius: 20px !important;
    }
  }
`

export const Header = styled.div`
  display: block;
  width: 100%;
  color: ${colors.white};
  background: ${colors.primary};
  justify-content: center;
`

export const Text = styled.div`
  font-family: ${fonts.primary};
  color: ${colors.white};
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 5px;
`

export const Content = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px;
  background: ${colors.white};
`

export const Arrow = styled.button`
  font-size: 10px;
  background-color: transparent;
  border: 1px solid transparent;
  transform: scale(1.5,2);
  margin: 0 10px;
  &:focus {
    border: none;
    outline: none;
  }
`

export const Date = styled.div`
  width: 170px;
  height: 25px;
  border: 1px solid ${colors.greySilver};
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  color: black;
`
